export interface ComicChapter {
  id: number;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: number;
  title: string;
  slug: string;
  author: string;
  artist: string;
  cover: string;
  description: string;
  categories: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  followers: number;
  updatedAt: string;
  chapters: ComicChapter[];
}

export const categories = [
  { slug: 'all', name: '全部' },
  { slug: 'romance', name: '恋爱' },
  { slug: 'fantasy', name: '奇幻' },
  { slug: 'action', name: '动作' },
  { slug: 'school', name: '校园' },
  { slug: 'mystery', name: '悬疑' },
  { slug: 'historical', name: '古风' },
  { slug: 'drama', name: '剧情' },
  { slug: 'horror', name: '惊悚' },
  { slug: 'martial', name: '武侠' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '女神降临',
    slug: 'goddess-descent',
    author: '喵喵',
    artist: '喵喵',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%20and%20flawless%20makeup%20transformation%2C%20soft%20romantic%20vibes%2C%20clean%20white%20background%2C%20elegant%20minimalist%20art%20style%2C%20warm%20lighting%2C%20professional%20digital%20illustration%20with%20smooth%20lineart&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '从小因为外貌被霸凌的任朱静，通过化妆技巧华丽变身为校园女神。在素颜与化妆之间游走的双重生活中，她遇到了两位截然不同的男生——高冷校草李修浩和阳光暖男韩书俊。三个人之间的感情纠葛，以及朱静对自我价值的探寻，构成了这部温暖治愈的校园恋爱故事。',
    categories: ['恋爱', '校园'],
    status: '已完结',
    rating: 4.8,
    views: 12800000,
    followers: 356000,
    updatedAt: '2026-07-28',
    chapters: [
      { id: 1, title: '第1话 新的开始', number: 1, updatedAt: '2022-03-15' },
      { id: 2, title: '第2话 变身', number: 2, updatedAt: '2022-03-22' },
      { id: 3, title: '第3话 相遇', number: 3, updatedAt: '2022-03-29' },
      { id: 50, title: '第50话 真心', number: 50, updatedAt: '2023-02-14' },
      { id: 100, title: '第100话 选择', number: 100, updatedAt: '2024-01-10' },
      { id: 150, title: '第150话 告白', number: 150, updatedAt: '2024-11-20' },
      { id: 200, title: '第200话 结局（上）', number: 200, updatedAt: '2025-08-15' },
      { id: 201, title: '第201话 结局（下）', number: 201, updatedAt: '2025-08-22' },
    ],
  },
  {
    id: 2,
    title: '我独自升级',
    slug: 'solo-leveling',
    author: 'Chugong',
    artist: 'Jang Sung-rak',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20illustration%20of%20a%20powerful%20male%20hunter%20with%20dark%20hair%20and%20glowing%20eyes%20surrounded%20by%20shadow%20soldiers%2C%20dark%20atmospheric%20background%20with%20purple%20energy%2C%20intense%20dramatic%20composition%2C%20professional%20digital%20art%20with%20detailed%20rendering&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '在一个连接异次元的"门"出现、觉醒者们猎杀怪物的世界里，最弱E级猎人成振宇在一次双重地下城事故后，获得了神秘系统——「玩家」的能力。从此他成为唯一可以无限升级的猎人，踏上从最弱到最强的逆袭之路。面对越来越强大的敌人，振宇逐渐揭开系统背后的真相。',
    categories: ['动作', '奇幻'],
    status: '已完结',
    rating: 4.9,
    views: 25600000,
    followers: 520000,
    updatedAt: '2026-07-30',
    chapters: [
      { id: 1, title: '第1话 最弱的猎人', number: 1, updatedAt: '2018-03-04' },
      { id: 50, title: '第50话 觉醒', number: 50, updatedAt: '2019-02-17' },
      { id: 100, title: '第100话 君临', number: 100, updatedAt: '2020-02-02' },
      { id: 150, title: '第150话 决战', number: 150, updatedAt: '2021-01-03' },
      { id: 179, title: '第179话 最终话', number: 179, updatedAt: '2021-07-25' },
    ],
  },
  {
    id: 3,
    title: '全知读者视角',
    slug: 'omniscient-reader',
    author: 'sing N song',
    artist: 'Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20illustration%20of%20a%20man%20in%20a%20white%20coat%20holding%20a%20book%20with%20mysterious%20constellations%20in%20the%20sky%20behind%20him%2C%20apocalyptic%20urban%20background%2C%20dramatic%20lighting%2C%20fantasy%20adventure%20art%20style%2C%20clean%20digital%20illustration&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '金独子是唯一读完长达3149话的网文《在灭亡的世界中存活的三种方法》的读者。当小说中的末日场景在现实中上演时，他成为了唯一知道这个世界走向的人。凭借着对剧情的了解，金独子在这个崩坏的世界中游走，与小说中的角色们相遇，试图改变既定的命运。',
    categories: ['奇幻', '动作'],
    status: '连载中',
    rating: 4.9,
    views: 18900000,
    followers: 430000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 唯一的读者', number: 1, updatedAt: '2020-05-26' },
      { id: 50, title: '第50话 星座的恩赐', number: 50, updatedAt: '2021-06-01' },
      { id: 100, title: '第100话 回归者', number: 100, updatedAt: '2022-07-15' },
      { id: 150, title: '第150话 新的故事', number: 150, updatedAt: '2023-09-20' },
      { id: 180, title: '第180话 序幕', number: 180, updatedAt: '2024-04-12' },
    ],
  },
  {
    id: 4,
    title: '甜蜜家园',
    slug: 'sweet-home',
    author: '金坎比',
    artist: '黄英璨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20horror%20illustration%20of%20a%20young%20man%20in%20a%20dark%20apartment%20hallway%20with%20monstrous%20shadow%20looming%20behind%2C%20tense%20atmospheric%20lighting%2C%20survival%20horror%20theme%2C%20clean%20digital%20art%20with%20strong%20contrast%2C%20minimalist%20background&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '遭遇校园霸凌和家庭变故的贤秀，搬到了一栋破旧的公寓楼准备结束自己的人生。然而末日降临，公寓楼外的世界变得异常恐怖——人们开始变异成可怕的怪物。贤秀与幸存的邻居们联手抵抗怪物，在绝望中寻找生的希望。而他自身，也在悄然发生着变化。',
    categories: ['惊悚', '剧情'],
    status: '已完结',
    rating: 4.7,
    views: 15200000,
    followers: 385000,
    updatedAt: '2026-07-25',
    chapters: [
      { id: 1, title: '第1话 新家', number: 1, updatedAt: '2017-10-12' },
      { id: 30, title: '第30话 感染', number: 30, updatedAt: '2018-05-17' },
      { id: 60, title: '第60话 选择', number: 60, updatedAt: '2019-01-10' },
      { id: 90, title: '第90话 牺牲', number: 90, updatedAt: '2019-08-22' },
      { id: 120, title: '第120话 结局', number: 120, updatedAt: '2020-03-15' },
    ],
  },
  {
    id: 5,
    title: '外貌至上主义',
    slug: 'lookism',
    author: '朴泰俊',
    artist: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20showing%20two%20contrasting%20versions%20of%20a%20person%2C%20one%20overweight%20and%20one%20handsome%2C%20split%20composition%2C%20school%20uniform%20theme%2C%20dramatic%20identity%20concept%2C%20clean%20digital%20art%20style%2C%20professional%20rendering&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '胖胖的高中生朴亨硕因外貌遭受校园霸凌，被迫转学。转学后他意外发现自己拥有了另一个完美的身体——当他睡觉时，会切换到一个高大帅气的身体中。白天用帅气身体上学、夜晚用原本身体打工，亨硕在两个身份间游走，逐渐看到了这个以外貌论英雄的世界的真实面貌。',
    categories: ['校园', '剧情'],
    status: '连载中',
    rating: 4.6,
    views: 16300000,
    followers: 410000,
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 两个我', number: 1, updatedAt: '2014-11-20' },
      { id: 100, title: '第100话 真相', number: 100, updatedAt: '2017-05-15' },
      { id: 200, title: '第200话 成长', number: 200, updatedAt: '2019-12-10' },
      { id: 300, title: '第300话 联盟', number: 300, updatedAt: '2022-04-05' },
      { id: 380, title: '第380话 战斗', number: 380, updatedAt: '2024-08-20' },
    ],
  },
  {
    id: 6,
    title: '神之塔',
    slug: 'tower-of-god',
    author: 'SIU',
    artist: 'SIU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20illustration%20of%20a%20boy%20climbing%20a%20massive%20mysterious%20tower%20with%20shimmering%20light%20above%2C%20fantasy%20world%20setting%2C%20epic%20adventure%20theme%2C%20clean%20digital%20art%2C%20vibrant%20colors%2C%20professional%20illustration&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '二十五夜是一个孤独的少年，他的整个世界就是一位名叫蕾哈尔的女孩。当蕾哈尔决定攀登神之塔后消失，夜追随她进入了这座充满谜团的巨塔。塔的每一层都是一个独立的世界，想要登顶必须通过残酷的试炼。夜在冒险中结识了各种伙伴，也发现了关于自己和这座塔的惊人秘密。',
    categories: ['奇幻', '冒险'],
    status: '连载中',
    rating: 4.8,
    views: 17500000,
    followers: 450000,
    updatedAt: '2026-08-02',
    chapters: [
      { id: 1, title: '第1话 蕾哈尔', number: 1, updatedAt: '2010-06-30' },
      { id: 80, title: '第80话 工坊之战', number: 80, updatedAt: '2013-10-07' },
      { id: 200, title: '第200话 地狱列车', number: 200, updatedAt: '2017-04-10' },
      { id: 350, title: '第350话 墙', number: 350, updatedAt: '2021-01-18' },
      { id: 450, title: '第450话 家族之争', number: 450, updatedAt: '2024-06-03' },
    ],
  },
  {
    id: 7,
    title: '大贵族',
    slug: 'noblesse',
    author: '孙齐皓',
    artist: '李光洙',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20an%20elegant%20noble%20vampire%20man%20in%20a%20black%20suit%20with%20silver%20hair%2C%20gothic%20mansion%20background%2C%20aristocratic%20vampire%20theme%2C%20clean%20digital%20art%20style%2C%20refined%20and%20mysterious%20atmosphere&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '沉睡820年的贵族——卡迪斯·艾特拉马·迪·莱杰罗在现代韩国醒来，进入了艺兰高中。身为拥有绝对力量的「大贵族」，他一边适应着平凡的校园生活，一边暗中保护着人类世界免受邪恶势力的侵害。忠诚的仆人弗兰克斯坦与其他改造人也陆续登场，共同守护着他们所珍视的一切。',
    categories: ['动作', '奇幻'],
    status: '已完结',
    rating: 4.7,
    views: 14200000,
    followers: 370000,
    updatedAt: '2026-07-20',
    chapters: [
      { id: 1, title: '第1话 觉醒', number: 1, updatedAt: '2007-12-30' },
      { id: 100, title: '第100话 团聚', number: 100, updatedAt: '2010-06-14' },
      { id: 200, title: '第200话 对决', number: 200, updatedAt: '2013-03-25' },
      { id: 300, title: '第300话 真相', number: 300, updatedAt: '2016-01-11' },
      { id: 400, title: '第400话 新世界', number: 400, updatedAt: '2018-10-08' },
      { id: 500, title: '第500话 终章', number: 500, updatedAt: '2021-05-16' },
    ],
  },
  {
    id: 8,
    title: '公爵的契约未婚妻',
    slug: 'duchess-contract',
    author: 'Milcha',
    artist: 'Whale',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20illustration%20of%20a%20beautiful%20woman%20in%20an%20elegant%20medieval%20fantasy%20dress%20with%20a%20handsome%2C%20cold%20duke%20behind%20her%2C%20romantic%20fantasy%20genre%2C%20soft%20warm%20lighting%2C%20castle%20interior%20background%2C%20clean%20digital%20art%20with%20delicate%20details&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '重生为小说中的配角——即将被丈夫杀害的公爵夫人，麦斯敏决定在悲剧发生之前改变一切。她主动向冷酷的诺克斯公爵提出契约婚姻，约定一年后和平分手。然而事与愿违，原本应该对她毫无感情的诺克斯公爵，却渐渐对这个自信聪慧的女人产生了别样的情愫。',
    categories: ['恋爱', '奇幻'],
    status: '连载中',
    rating: 4.7,
    views: 11200000,
    followers: 320000,
    updatedAt: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 重生', number: 1, updatedAt: '2021-03-12' },
      { id: 30, title: '第30话 契约', number: 30, updatedAt: '2021-10-05' },
      { id: 60, title: '第60话 危机', number: 60, updatedAt: '2022-07-20' },
      { id: 90, title: '第90话 心动', number: 90, updatedAt: '2023-05-15' },
      { id: 110, title: '第110话 坦白', number: 110, updatedAt: '2024-02-08' },
    ],
  },
  {
    id: 9,
    title: '某天成为公主',
    slug: 'became-princess',
    author: 'Plutus',
    artist: 'Spoon',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20a%20cute%20young%20princess%20with%20blonde%20hair%20and%20blue%20eyes%20in%20a%20beautiful%20fantasy%20dress%2C%20royal%20palace%20background%2C%20fairy%20tale%20atmosphere%2C%20family%20drama%20theme%2C%20clean%20digital%20art%20with%20soft%20pastel%20colors&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '重生为小说《可爱的公主》中的悲剧女主角阿塔纳西娅，她发现自己注定在18岁被亲生父亲——冷酷无情的皇帝克劳德处死。为了活下去，她决定改变策略：不再做一个乖巧的公主，而是努力讨好这位冷血的父亲。然而当她真的开始理解克劳德背后的故事时，一切变得复杂起来。',
    categories: ['恋爱', '奇幻'],
    status: '已完结',
    rating: 4.8,
    views: 13500000,
    followers: 380000,
    updatedAt: '2026-07-18',
    chapters: [
      { id: 1, title: '第1话 公主诞生', number: 1, updatedAt: '2017-12-20' },
      { id: 30, title: '第30话 父亲的目光', number: 30, updatedAt: '2018-08-15' },
      { id: 60, title: '第60话 宴会', number: 60, updatedAt: '2019-05-10' },
      { id: 90, title: '第90话 记忆', number: 90, updatedAt: '2020-03-25' },
      { id: 125, title: '第125话 终章', number: 125, updatedAt: '2020-12-28' },
    ],
  },
  {
    id: 10,
    title: '反派死亡结局',
    slug: 'villains-destiny',
    author: 'Gwon Gyeoeul',
    artist: 'SUOL',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20illustration%20of%20a%20villainess%20woman%20with%20dark%20hair%20and%20red%20eyes%20in%20an%20opulent%20fantasy%20dress%2C%20dramatic%20lighting%2C%20dark%20romance%20theme%2C%20gothic%20mansion%20interior%2C%20clean%20digital%20illustration%20with%20strong%20emotional%20expression&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '平凡大学生穿越到了她正在玩的乙女游戏中，却意外成为了游戏中注定被所有攻略对象杀死的反派——佩内洛普·埃卡特。如果不想在游戏通关时迎来死亡结局，她必须让至少一位攻略对象爱上她。但问题是，这些攻略对象——王子、骑士、魔法师——个个都对她恨之入骨。她能改写自己的命运吗？',
    categories: ['恋爱', '剧情'],
    status: '连载中',
    rating: 4.8,
    views: 14800000,
    followers: 400000,
    updatedAt: '2026-08-05',
    chapters: [
      { id: 1, title: '第1话 穿越', number: 1, updatedAt: '2020-04-30' },
      { id: 30, title: '第30话 第一条线', number: 30, updatedAt: '2021-01-05' },
      { id: 60, title: '第60话 选择', number: 60, updatedAt: '2021-10-12' },
      { id: 90, title: '第90话 反转', number: 90, updatedAt: '2022-08-18' },
      { id: 120, title: '第120话 真实', number: 120, updatedAt: '2023-07-01' },
    ],
  },
  {
    id: 11,
    title: '重生之将门毒后',
    slug: 'rebirth-fierce-consort',
    author: '千山茶客',
    artist: 'Lidong',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20historical%20illustration%20of%20a%20fierce%20beautiful%20woman%20in%20traditional%20Chinese%20ancient%20hanfu%20dress%20with%20sword%2C%20palace%20intrigue%20theme%2C%20dramatic%20wind-swept%20scene%2C%20martial%20art%20and%20romance%20fusion%2C%20clean%20digital%20art%20with%20elegant%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '将门嫡女沈妙前世错付真心，最终家破人亡、含恨而终。一朝重生回到十四岁那年，她发誓要让所有伤害过她的人付出代价。她步步为营，斗继母、灭渣男、护家族，在复仇的道路上却意外遇见了那个前世默默守护她一生的男人——谢景行。这一次，她不会再错过。',
    categories: ['古风', '恋爱'],
    status: '连载中',
    rating: 4.6,
    views: 9800000,
    followers: 290000,
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 重生', number: 1, updatedAt: '2022-01-15' },
      { id: 25, title: '第25话 反击', number: 25, updatedAt: '2022-08-10' },
      { id: 50, title: '第50话 棋局', number: 50, updatedAt: '2023-04-05' },
      { id: 75, title: '第75话 联手', number: 75, updatedAt: '2023-12-20' },
      { id: 90, title: '第90话 风云', number: 90, updatedAt: '2024-07-14' },
    ],
  },
  {
    id: 12,
    title: '剑尊归来',
    slug: 'sword-master-returns',
    author: 'Redice Studio',
    artist: 'Redice Studio',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20martial%20arts%20illustration%20of%20a%20swordsman%20in%20traditional%20martial%20arts%20robe%20with%20flowing%20dark%20hair%20holding%20a%20glowing%20sword%2C%20mountain%20peak%20background%20with%20moonlight%2C%20epic%20wuxia%20theme%2C%20clean%20digital%20art%20with%20dynamic%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '被誉为天下第一剑的「剑尊」赵天，在与魔教教主的大战中陨落。百年后，他以少年之身重生，却发现曾经的辉煌门派已然没落，江湖格局天翻地覆。带着前世记忆和绝世剑法，赵天重新踏上修炼之路，誓要重振师门威名，同时揭开当年陨落背后隐藏的秘密。',
    categories: ['武侠', '动作'],
    status: '连载中',
    rating: 4.5,
    views: 7600000,
    followers: 220000,
    updatedAt: '2026-08-01',
    chapters: [
      { id: 1, title: '第1话 陨落与重生', number: 1, updatedAt: '2023-02-28' },
      { id: 20, title: '第20话 初显锋芒', number: 20, updatedAt: '2023-08-15' },
      { id: 40, title: '第40话 剑阁试炼', number: 40, updatedAt: '2024-02-10' },
      { id: 55, title: '第55话 旧敌', number: 55, updatedAt: '2024-08-05' },
    ],
  },
];

export function getComicsByCategory(categorySlug: string): Comic[] {
  if (categorySlug === 'all') return comics;
  const category = categories.find((c) => c.slug === categorySlug);
  if (!category) return [];
  return comics.filter((comic) => comic.categories.includes(category.name));
}

export function getComicById(id: number): Comic | undefined {
  return comics.find((comic) => comic.id === id);
}

export function getPopularComics(limit: number = 10): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestComics(limit: number = 10): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
}

export function getFeaturedComics(): Comic[] {
  return [comics[1], comics[2], comics[0], comics[5]];
}